import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = ["data-value", "data-id", "onUpdate:modelValue"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "ms-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("More Details ")
const _hoisted_7 = ["data-bs-target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CardTable, {
      ref: "tableRef",
      name: "Order",
      header: $setup.tableHeader,
      breadcrumbs: $setup.breadcrumbs,
      endpoint: `order${$props.query}`,
      filterData: $setup.filterData,
      hasQueryParam: $props.query ? true : false
    }, {
      "cell-status": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_1, [
          (!$setup.nonChangeableStatuses.includes(row.status))
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                class: _normalizeClass([`select-${$setup.Colors[row.status]}`, "form-select form-select-solid fs-6 p-1 fw-bolder bg-white"]),
                name: "Order Status",
                "data-value": row.status,
                "data-id": row.id,
                "onUpdate:modelValue": ($event: any) => ((row.status) = $event),
                onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleChange($event))),
                key: $setup.componentKey
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getFilteredStatuses(row.status), (status, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: status[0]
                  }, _toDisplayString(status[1]), 9, _hoisted_3))
                }), 128)),
                _createElementVNode("option", {
                  hidden: "",
                  value: row.status
                }, _toDisplayString($setup.Statuses[row.status]), 9, _hoisted_4)
              ], 42, _hoisted_2)), [
                [_vModelSelect, row.status]
              ])
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([`select-${$setup.Colors[row.status]}`, "form-select form-select-solid fs-6 p-1 fw-bolder bg-white text-start"])
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.Statuses[row.status]), 1)
              ], 2))
        ])
      ]),
      "cell-details": _withCtx(({ row }) => [
        _createVNode(_component_router_link, {
          style: {"min-width":"151px"},
          class: "btn px-8 py-2 text-uppercase btn-primary",
          to: `/order/${row.id}?status=${$setup.Statuses[row.status]}`
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      "cell-id": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.id.slice(16).toUpperCase()), 1)
      ]),
      "cell-type": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString($setup.convertCamelToTitle(row.package?.id)), 1)
      ]),
      "cell-createdAt": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString($setup.moment(row.createdAt).format('DD/MM/YYYY')), 1)
      ]),
      "cell-startDate": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString($setup.moment(row.startDate).format('DD/MM/YYYY')), 1)
      ]),
      "cell-endDate": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString($setup.moment(row.endDate).format('DD/MM/YYYY')), 1)
      ]),
      "cell-customer": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.customer?.name || 'WESERVE'), 1)
      ]),
      "cell-amountPrice": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.price?.full), 1)
      ]),
      _: 1
    }, 8, ["header", "breadcrumbs", "endpoint", "filterData", "hasQueryParam"]),
    _createVNode(_component_ConfirmModal, {
      canBack: true,
      idProps: "change-status",
      message: "Are you sure you want to change this order's status?"
    }, {
      cancel: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          name: "cancel",
          class: "btn btn-danger px-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.currentEvent.target.value = $setup.currentEvent.target.dataset.value)),
          "aria-label": "Close",
          "data-bs-toggle": "modal",
          "data-bs-target": "#change-status"
        }, " Cancel ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
        !$setup.nonChangeableStatuses.includes($setup.currentEvent.target.value)
          ? $setup.changeStatus(
              $setup.currentEvent.target.value,
              $setup.currentEvent.target.dataset.id,
              () => $setup.rerender()
            )
          : null
      )),
          "data-bs-toggle": "modal",
          "data-bs-target": $setup.modalId,
          type: "button",
          name: "confirm",
          class: "btn btn-primary px-10"
        }, " Change ", 8, _hoisted_7)
      ]),
      _: 1
    }),
    _createVNode(_component_ConfirmModal, {
      title: "Are you REALLY sure?",
      canBack: true,
      idProps: "second-confirmation",
      message: "Changing status to completed or canceled cannot be undone"
    }, {
      cancel: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          name: "cancel",
          class: "btn btn-danger px-10",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.currentEvent.target.value = $setup.currentEvent.target.dataset.value)),
          "aria-label": "Close",
          "data-bs-toggle": "modal",
          "data-bs-target": "#second-confirmation"
        }, " No ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (
        $setup.changeStatus(
          $setup.currentEvent.target.value,
          $setup.currentEvent.target.dataset.id,
          () => $setup.rerender()
        )
      )),
          "data-bs-toggle": "modal",
          "data-bs-target": "#second-confirmation",
          type: "button",
          name: "confirm",
          class: "btn btn-primary px-10"
        }, " Yes ")
      ]),
      _: 1
    })
  ], 64))
}